import Lottie, { AnimationItem } from 'lottie-web';
import {
  OnInit,
  Component,
  HostBinding,
  Input,
  OnChanges,
  SimpleChanges,
  OnDestroy,
  Inject,
  HostListener,
  ViewChild,
  AfterViewInit,
} from '@angular/core';

import * as animationData from '../../../../../assets/lottie-animation/Logo.json';

import { SubSink } from 'subsink';
import { BookAnimationController } from 'src/app/shared';
import { MainLogoAnimService } from 'src/app/feature/services';
import { IS_SERVER_PLATFORM } from 'src/app/core';

@Component({
  selector: 'app-logo-animation',
  templateUrl: './logo-animation.component.html',
  styleUrls: ['./logo-animation.component.scss'],
})
export class LogoAnimationComponent
  implements OnInit, AfterViewInit, OnChanges, OnDestroy
{
  @HostBinding('class.main-animation') mainAnimation = true;
  @Input() animationId!: string;
  @Input() isHandset!: boolean;
  @Input() height!: number;

  @ViewChild('.animation', {}) animationBook!: {
    nativeElement: HTMLDivElement;
  };

  private htmlBookElement?: SVGFEFuncGElement;

  public animationController!: BookAnimationController;
  public animController?: BookAnimationController;
  public nativeAnimationItem!: AnimationItem;
  public animationItem?: AnimationItem;
  public normalState = new Map();

  private subsink = new SubSink();

  ngOnInit() {
    this.subsink.sink = this.logoAnimationService.animHeight$.subscribe({
      next: (value) => {
        this.height = value;
        this.updateAndRun(value);
      },
    });

    this.subsink.sink = this.logoAnimationService.animDestroy$.subscribe({
      next: () => {
        this.destroyAnimation();
      },
    });

    this.subsink.sink =
      this.logoAnimationService.animationRefreshSubject$.subscribe({
        next: () => {},
      });
  }

  constructor(
    @Inject('LOTTIE_WEB') private lottieWeb: typeof Lottie,
    private logoAnimationService: MainLogoAnimService,
    @Inject(IS_SERVER_PLATFORM) private isServer: boolean
  ) {}

  ngAfterViewInit(): void {
    const animationBookElement = document.querySelector(`#${this.animationId}`);
    const book = animationBookElement?.querySelector('.book');
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['height'] &&
      changes['height'].previousValue &&
      changes['height'].currentValue !== changes['height'].previousValue
    ) {
      this.height = changes['height'].currentValue;
      this.updateAndRun(this.height);
    }
  }

  public updateAndRun(height?: number, frame?: number) {
    if (this.isServer) {
      return;
    }

    if (!this.animController) {
      this.animController = new BookAnimationController(
        JSON.stringify(animationData)
      );
    }

    this.animController.setHeight(height || 1000);

    this.destroyAnimation();
    this.animationItem = this.lottieWeb.loadAnimation({
      container: document.getElementById(this.animationId) as Element,
      renderer: 'svg',
      loop: false,
      autoplay: false,
      animationData: this.animController.getAnimationData(),
    });

    window.scrollBy(0, 1);
  }

  @HostListener('document:scroll')
  public eventListener? = () => {
    const duration = 950;

    const scrollPosition = window.scrollY;
    const maxFrames = this.animationItem?.totalFrames;
    if (maxFrames) {
      const frame = (maxFrames / 100) * (scrollPosition / (duration / 100));

    if (this.animationItem && frame > this.animationItem?.totalFrames!) {
      this.animationItem!.goToAndStop(this.animationItem?.totalFrames!, true);
    } else {
      this.animationItem!.goToAndStop(frame, true);
    }
    }
  };

  // ------------------------------------------------Private Methods|

  private destroyAnimation() {
    this.animationItem?.destroy();
    delete this.animationItem;
    this.lottieWeb.destroy();
    this.animationItem = undefined;
  }

  ngOnDestroy() {
    if (this.isServer) {
      return;
    }

    this.subsink.unsubscribe();
    this.destroyAnimation();
    this.animationItem = undefined;
    document.removeEventListener('scroll', this.eventListener!);

    this.eventListener = () => {};
  }
}
